import { findKey } from 'lodash';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';
import { GoogleMap } from '@zocdoc/components/src/GoogleMap';

export class CarouselMap extends GoogleMap {
    static propTypes = Object.assign({}, GoogleMap.propTypes, {
        locationId: PropTypes.string.isRequired,
        setLocation: PropTypes.func.isRequired,
    });

    componentDidMount() {
        return super.componentDidMount().then(this.recenterMap);
    }

    recenterMap = () => {
        const { locationId } = this.props;

        if (locationId && this.map) {
            this.map.setCenter(this.markersByEntityLocationId[locationId].position);
        }
    }

    componentDidUpdate(prevProps) {
        super.componentDidUpdate(prevProps);

        const { locationId } = this.props;
        if (locationId && locationId !== prevProps.locationId && this.map) {
            this.markersByEntityLocationId[locationId].selected = true;
            this.recenterMap();

            if (prevProps.locationId) {
                this.markersByEntityLocationId[prevProps.locationId].selected = false;
            }
        }
    }

    onClickMarker(latlngKey) {
        this.moveCarouselToDoctor(latlngKey);
    }

    moveCarouselToDoctor(latlngKey) {
        const marker = this.markers[latlngKey];
        marker.selected = true;

        const locationId = findKey(this.markersByEntityLocationId, marker);

        if (locationId) {
            this.props.setLocation(locationId);
        }
    }
}

export const CarouselMapWithTheme = withTheme(CarouselMap);
